import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import UserStore from '../../util/UserStore';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import $ from 'jquery';
import { isMobile, isTablet } from 'react-device-detect';
import HawkEye from '../../util/HawkEye';

export default class ExternalLogin extends PreLoginPage{
	
	constructor(props) {
		super(props);
		this.UserStore = new UserStore();
		this.navigationKey="PLP_Navigation";
		this.navigateURLKey="PLP_REDIRECT";
		this.navigateObj = {};
		
		this.doLumosLogout = this.doLumosLogout.bind(this);
	}

	updateUserType(commonCallback){
		var me=this;
		var callBackSuccess = function(response){
			if(response!== null){
				//console.warn("user type",response)
				me.UserStore.set(response);
			}

			if(typeof commonCallback === "function"){
				commonCallback.apply(this);
			}
		}

		var callBackFailure = function(response){
			//console.warn("failure ",response);

			if(typeof commonCallback === "function"){
				commonCallback.apply(this);
			}
		}

		super.updateUserType(callBackSuccess,callBackFailure)
	}

	productsAvailableToAccess(userobj){
		var user = userobj;
		//console.log("user::::",user);
		if(user != null){
			var permissions = user.entlHistory;//console.log("permissions:::",permissions);
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}
	
	componentDidMount() {
		var me = this;
		var success = function(userObj){
			console.log("External login ajax success...");
			if(typeof userObj === "object" && userObj.authToken){
				//Update the userStore Object
				me.UserStore.set(userObj);
				
				try{
					me.doLumosLogout();
				}catch(e){}


				try {
					me.navigateObj = JSON.parse(BrowserStorageUtil.getStoredSessionItem(me.navigationKey)); 

					let redirectUri = null; 

					if(me.productsAvailableToAccess(userObj)){
						redirectUri = "/landing";
					}else{
						redirectUri = (me.navigateObj && me.navigateObj.navigateURL) ? me.navigateObj.navigateURL : "/" ;
					}

					
					//console.log(me.navigateObj);
					/*if(me.navigateObj.navigateURL){
						me.props.history.push(me.navigateObj.navigateURL);
					}else{
						me.props.history.push('/landing');
					}*/
					console.log("me.navigateObj.navigateURL"+me.navigateObj.navigateURL);
					/*try{
						me.trackMe(true,userObj);
					}catch(e){}*/
					
					try{
						var loginObj = {
							"user_id" : (userObj == null) ? "" : userObj.userId,
							"login_id" : (userObj == null) ? "" : userObj.loginId,
							"user_agent" : navigator.userAgent,
							"platform" : navigator.platform,
							"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
							"ip_address" : "ip_address",
							"result" : true,
							"session_id" : (userObj == null) ? "" : userObj.authToken
						}
						
						me.storeTrackEvent("login", loginObj);
					}catch(e){}
					
					
					
					/*if(userObj && userObj.userRole.role == "PRNT"){
						if(me.navigateObj.navigateURL == "/landing"){
							me.props.history.push('/myproducts');
						}else{
						me.props.history.push(me.navigateObj.navigateURL);
						}
					}else{
						me.props.history.push('/landing');
					}*/

					let afterUpdate = function(){
						if(me.navigateObj.navigateURL && me.navigateObj.navigateURL.match("http[s]?://+")){
						 	window.location.href= redirectUri;
						}else{
							me.props.history.push(redirectUri);
						}						
					};
					me.updateUserType(afterUpdate);
					
				} catch (e) {}

				
			}else{
				//Clear userStore
				me.UserStore.clearOldUser();
			}
		
		}

		var failure = function(error){
			//User session is no longer valid
			console.log("External login ajax failure...");
		}
		
		this.sessionCheck(success,failure, true);

		if(!this.tracked){
				this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-via-google"});
				this.tracked = true;
		}		
	}
	trackMe(result,userObj=null){
		var trackObj = {
			"user_id" : (userObj == null) ? "" : userObj.userId,
			"login_id" : (userObj == null) ? "" : userObj.loginId,
			"user_agent" : navigator.userAgent,
			"platform" : navigator.platform,
			"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
			"ip_address" : "ip_address",
			"result" : (result === true),
			"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	initiateTrack(trackKey, addnldata){
		try{
			var eventObj = this.getTracker();
			
			var trackObj = eventObj.getEventObject(eventObj.eventCodes[trackKey]);

			trackObj.event_details.user_id = addnldata.user_id || "";
			trackObj.event_details.session_id = addnldata.authToken || "";
			trackObj.event_details.timestamp = new Date().getTime() || "";			
			
			if(addnldata !== undefined && typeof addnldata === "object"){
				for(var key in addnldata){
					trackObj.event_data[key] = addnldata[key];
				}
			}
			
			var output = {"event":trackObj};
			   		
			new HawkEye(output).post();
		}catch(e){
			console.log("Error in Tracking :::",e);
		}
	}
	doLumosLogout(){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
			url: me.getUrlFor("LUMOS_LOGOUT"),	            
			type: 'GET',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){	            	

			},
			error: function(response){
				console.log("Error in LUMOS_LOGOUT",response);
			}
		});
	}

	render() {	
		
		return (  
			<div> {this.showLoader()}</div>
			);
	}
}


// WEBPACK FOOTER //
// ./src/views/extlogin/ExternalLogin.js